<script setup lang="ts">
import { useFormErrors } from 'vee-validate'
import IconButton from '@/components/IconButton/index.vue'

const formErros = useFormErrors()
const formErrosParsed = computed(() => {
  return Object.entries(formErros.value).reduce((acc, errorPar) => {
    const [_, error] = errorPar
    if (error)
      acc.push(error)

    return acc
  }, [] as string[])
})

const toast = useToast()

watch(formErrosParsed, (errors) => {
  if (errors.length > 0)
    toast.error(errors.join('\n'))
})
</script>

<template>
  <Popper v-if="formErrosParsed.length > 0">
    <IconButton
      icon="i-material-symbols:error-outline-rounded  h-10 w-10"
      aria-label="Show Errors"
      icon-class=" w-7 h-7 text-red"
    />
    <template #content>
      <ul
        class="bg-white border border-gray-200 rounded-lg shadow-lg p-2 flex flex-col gap-1 font-inter"
      >
        <li
          v-for="error in formErrosParsed"
          :key="error"
          class="text-red text-xs"
        >
          {{ error }}
        </li>
      </ul>
    </template>
  </Popper>
</template>
